<template>
    <div class="scheme">
        <div class="mbx clearfix">
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>顾问招募</el-breadcrumb-item>
                <el-breadcrumb-item>往期回顾</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="fr" @click="addSchemeDialogVisible = true">添加</el-button>

            <el-dialog title="新增" :visible.sync="addSchemeDialogVisible" width="50%" center>
                <el-form :model="shemeForm" :rules="rules" ref="shemeForm">
                    <el-form-item label="标题" prop="title" :label-width="formLabelWidth">
                        <el-input type="textarea" v-model="shemeForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="跳转链接" prop="reviewTrainUrl" :label-width="formLabelWidth">
                        <el-input type="text" v-model="shemeForm.reviewTrainUrl"></el-input>
                    </el-form-item>
                    <el-form-item label="图片上传" :label-width="formLabelWidth">
                        <el-upload class="upload-demo" :action="url" :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="uploadSuccedd" :limit="1" show-file-list :on-exceed="handleExceed" :before-upload="beforeAvatarUpload">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">文件大小不能超过2M</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="图片" :label-width="formLabelWidth">
                        <template>
                            <img style="display:block;width:100%;height:100%;" :src="Baseurl+shemeForm.reviewTrainImg" alt="">
                        </template>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="addSchemeDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addScheme('shemeForm')">确 定</el-button>
                </span>
            </el-dialog>

        </div>

        <el-table :data="tableData.list" border style="width: 100%">
            <el-table-column prop="title" label="标题" width="380">
            </el-table-column>
            <el-table-column prop="reviewTrainUrl" label="跳转链接" width="380">
            </el-table-column>
            <el-table-column prop="reviewTrainImg" label="图片">
                <template slot-scope="scope">
                    <img :src="Baseurl+scope.row.reviewTrainImg" width="300" height="100" class="head_pic" />
                </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="amendClick(scope.row)" type="text" size="small">修改</el-button>
                    <el-button v-if="scope.row.reviewTrainStatus !== 1" type="text" @click="alterState(1,scope.row)" size="small">发布</el-button>
                    <el-button v-if="scope.row.reviewTrainStatus !== 2" type="text" @click="alterState(2,scope.row)" size="small">下架</el-button>
                    <el-button v-if="scope.row.reviewTrainStatus !== 3" type="text" @click="alterState(3,scope.row)" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination v-model="tableData" @current-change="handleCurrentChange" :current-page.sync="tableData.pageNum" layout="total, prev, pager, next, jumper" :total="tableData.total">
            </el-pagination>
        </div>
        <!-- 修改的弹窗 -->
        <el-dialog title="修改解决方案" :visible.sync="amendSchemeDialogVisible" width="50%" center>
            <el-form :model="shemeAmendForm" :rules="rules" ref="shemeAmendForm">
                <el-form-item label="文案" prop="title" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="shemeAmendForm.title"></el-input>
                </el-form-item>
                <el-form-item label="跳转链接" prop="reviewTrainUrl" :label-width="formLabelWidth">
                    <el-input type="text" v-model="shemeAmendForm.reviewTrainUrl"></el-input>
                </el-form-item>
                <el-form-item label="文件上传" :label-width="formLabelWidth">
                    <el-upload class="upload-demo" :action="url" :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="uploadSuccedd" :limit="1" show-file-list :on-exceed="handleExceed" :before-upload="beforeAvatarUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">文件大小不能超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="图片" :label-width="formLabelWidth">
                    <template>
                        <img style="display:block;width:100%;height:100%;;" :src="Baseurl+shemeAmendForm.reviewTrainImg" alt="">
                    </template>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="amendSchemeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="amendScheme('shemeAmendForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { revieWtrain, addReviewTrain, updateReviewTrain } from '../api/api.js'
    export default {
        name: 'review',
        created() {
            revieWtrain().then((res) => {
                this.tableData = res.data.data;
            })
        },
        data() {
            return {
                url: this.GLOBAL.uploderPicURL,
                Baseurl: this.GLOBAL.picURL,
                tableData: [],
                shemeForm: {
                    title: '',
                    reviewTrainImg: ''
                },
                shemeAmendForm: {},
                addSchemeDialogVisible: false,
                amendSchemeDialogVisible: false,
                formLabelWidth: '100px',
                rules: {
                    title: [
                        { required: true, message: '请输入文案', trigger: 'blur' }
                    ],
                    reviewTrainUrl: [
                        { required: true, message: '请输入跳转链接', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            // 修改点击
            amendClick(param) {
                this.amendSchemeDialogVisible = true;
                this.shemeAmendForm = param;
            },
            amendScheme() {
                let data = {
                    reviewTrainId: this.shemeAmendForm.reviewTrainId,
                    title: this.shemeAmendForm.title,
                    reviewTrainImg: this.shemeAmendForm.reviewTrainImg,
                    reviewTrainUrl: this.shemeAmendForm.reviewTrainUrl
                }
                updateReviewTrain(data).then(res => {
                    if (res.status === 1) {
                        this.amendSchemeDialogVisible = false;
                        this.$message({
                                message: '修改成功',
                                type: 'success'
                            }),
                            this.shemeAmendForm = {};
                        revieWtrain().then((res) => {
                            this.tableData = res.data.data;
                        })
                    }
                })
            },
            // 添加点击
            addScheme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        addReviewTrain(this.shemeForm).then((res) => {
                            if (res.status === 1) {
                                this.addSchemeDialogVisible = false;
                                this.$refs[formName].resetFields();
                                this.$message({
                                        message: '添加成功',
                                        type: 'success'
                                    }),
                                    revieWtrain().then((res) => {
                                        this.tableData = res.data.data;
                                    })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
                this.addSchemeDialogVisible = false
            },
            handleRemove(file, fileList) {
                this.$message.warning(`成功删除文件，请重新选取文件`);
                this.shemeForm.reviewTrainImg = '';
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            // 上传图片
            uploadSuccedd(file) {
                this.shemeForm.reviewTrainImg = file.data.filePath;
                this.shemeAmendForm.reviewTrainImg = file.data.filePath;
            },
            // 分页
            handleCurrentChange(val) {
                revieWtrain({ pageNum: val }).then((res) => {
                    this.tableData = res.data.data;
                })
            },
            // 修改状态
            alterState(state, json) {
                this.$confirm('确定要删除？', '提示', {
                    type: 'warning'
                }).then(() => {
                    let message = '';
                    switch (state) {
                    case 1:
                        message = '发布成功'
                        break;
                    case 2:
                        message = '下架成功'
                        break;
                    case 3:
                        message = '删除成功'
                        break;
                    }
                    let data = {
                        reviewTrainStatus: state,
                        reviewTrainId: json.reviewTrainId
                    }
                    updateReviewTrain(data).then(res => {
                        if (res.status === 1) {
                            this.$message({
                                    message: message,
                                    type: 'success'
                                }),
                                revieWtrain().then((res) => {
                                    this.tableData = res.data.data;
                                })
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .mbx {
        background-color: #f5f5f5;
        padding: 1% 4%;
    }

    .block {
        float: right
    }
</style>



// WEBPACK FOOTER //
// src/components/ht_review.vue